import { render } from "./TheUserDocuments.vue?vue&type=template&id=b963b026"
import script from "./TheUserDocuments.vue?vue&type=script&lang=js"
export * from "./TheUserDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__